<div class="tile-container" [class]="{ active: (isActive$ | async) }">
  <div class="title-bar">
    <div class="title">
      <span [matTooltip]="instance.title" matTooltipPosition="above" matTooltipShowDelay="500">{{ instance.title }}</span>
      <ng-container *ngIf="(isActive$ | async) !== null; else loadingStatusBadge">
        <div [ngClass]="{ 'status-badge': true, hidden: !activeBadgeClass }">
          <mat-icon [svgIcon]="activeBadgeClass"></mat-icon>
          {{ activeBadgeText }}
        </div>
      </ng-container>
      <ng-template #loadingStatusBadge>
        <div class="status-badge-loader">
          <mat-progress-spinner [diameter]="14" [strokeWidth]="2" color="accent" mode="indeterminate"></mat-progress-spinner>
        </div>
      </ng-template>
    </div>
    <mat-icon class="menu-icon" svgIcon="menu-16" [matMenuTriggerFor]="menu"></mat-icon>
  </div>
  <div class="content">
    <div *ngFor="let info of instanceInfo">
      <div class="info-label">{{ info.label }}</div>
      <div class="info-value">{{ info.value }}</div>
    </div>
  </div>
  <div class="button-bar">
    <ng-container *ngIf="(isActive$ | async) !== null; else loadingActiveState">
      <brd-button
        *ngIf="!isLoading; else loadingBtn"
        [text]="(isActive$ | async) ? 'open' : 'restart'"
        [color]="(isActive$ | async) ? 'primary' : 'secondary'"
        [iconName]="(isActive$ | async) ? 'open-up-16' : 'reload-16'"
        [class]="{ 'restart-btn': (isActive$ | async) === false }"
        (click)="handleButtonClick($event)"
      ></brd-button>
    </ng-container>
    <ng-template #loadingActiveState>
      <div class="active-state-loader">
        <mat-progress-spinner [diameter]="16" [strokeWidth]="2" color="accent" mode="indeterminate"></mat-progress-spinner>
      </div>
    </ng-template>
    <ng-template #loadingBtn>
      <button mat-stroked-button class="btn-loader">
        <div class="btn-loader-content">
          <mat-progress-spinner [diameter]="18" [strokeWidth]="3" color="primary" mode="indeterminate"></mat-progress-spinner
          >{{ loadingBtnText }}
        </div>
      </button>
    </ng-template>
    <brd-button color="no-border" text="info" iconName="info-16" (clickEvent)="infoButtonClick($event)"></brd-button>
  </div>
</div>
<mat-menu #menu="matMenu" class="instance-menu" overlayPanelClass="instance-menu-panel">
  <button mat-menu-item class="custom-menu-item" *ngIf="isActive$ | async" (click)="openNewWindow($event, instance.linkAdminPortal)">
    <mat-icon svgIcon="gear-16"></mat-icon>
    <span>Go to Admin Portal</span>
  </button>
  <button mat-menu-item class="custom-menu-item" *ngIf="isActive$ | async" (click)="openNewWindow($event, instance.linkSubHub)">
    <mat-icon svgIcon="user-idp-16"></mat-icon>
    <span>Go to Subscription Hub</span>
  </button>
  <div mat-menu-item class="divider" *ngIf="isActive$ | async"></div>
  <button mat-menu-item class="custom-menu-item" (click)="copyTextToClipboard($event, instance.link)">
    <mat-icon svgIcon="copy-16"></mat-icon>
    <span>Copy Demo URL</span>
  </button>
  <div mat-menu-item class="divider"></div>
  <button
    mat-menu-item
    class="custom-menu-item"
    *ngIf="instance.powerStateText === 'Online'"
    (click)="stopDemo($event, instance.title, instance.id)"
  >
    <mat-icon svgIcon="sleep-16"></mat-icon>
    <span>Put in Sleep Mode</span>
  </button>
  <div mat-menu-item class="divider" *ngIf="instance.powerStateText === 'Online'"></div>
  <button
    mat-menu-item
    class="custom-menu-item"
    *ngIf="!isLoading && instance.canDelete"
    (click)="deleteDemo($event, instance.title, instance.id, instance.owner)"
  >
    <mat-icon svgIcon="trash-16"></mat-icon>
    <span>Delete</span>
  </button>
  <div mat-menu-item class="divider" *ngIf="!isLoading && instance.canDelete"></div>
  <button mat-menu-item class="custom-menu-item" (click)="askSupprt()">
    <mat-icon svgIcon="label-16"></mat-icon>
    <span>Ask support</span>
  </button>
  <button mat-menu-item class="custom-menu-item" (click)="infoSnapshotClick($event)" *ngIf="instance.canDelete">
    <mat-icon svgIcon="cloud-arrow-up-16"></mat-icon>
    <span>Demo snapshot</span>
  </button>
</mat-menu>

<ng-template #infodialog let-data="data">
  <div class="info-container">
    <div class="info-body-container">
      <brd-instance-tile-info [instance]="instance"></brd-instance-tile-info>
      <div class="how-to-section" *ngIf="canAccess; else noAccess">
        <h2 class="title">HOW TO ACCESS YOUR BOARD DEMO</h2>
        <div>
          To access your demo environment, click the “Open” button or go to the following
          <a [href]="instance.link" target="_blank">link</a>.
        </div>
        <div>You will be able to access it from any browser, using any of the following credentials:</div>
        <div class="users">
          <div class="credential" *ngFor="let account of accounts">
            <div class="text">
              <div>
                Username: <strong>{{ account }}</strong>
              </div>
              <div *ngIf="hasSSOEnabled(); else pwdTemplate">Password: SSO Enabled</div>
              <ng-template #pwdTemplate>
                <div>
                  Password: <strong>{{ data.password }}</strong>
                </div>
              </ng-template>
            </div>
            <div class="icons">
              <mat-icon svgIcon="copy-16" (click)="copyTextToClipboard($event, account)"></mat-icon>
              <mat-icon *ngIf="!hasSSOEnabled()" svgIcon="copy-16" (click)="copyTextToClipboard($event, data.password)"></mat-icon>
            </div>
          </div>
        </div>
        <div>
          Each demo environment automatically includes the users listed above (as admins), so you can easily simulate all functions of the
          BOARD Platform.<br />
          You can also add further users as required.
        </div>
        <div class="hdp-section">
          To access the Demo Data pipeline, you can use the following <a [href]="hdpAddress" target="_blank">link</a> and using the
          following credentials:
          <div class="credential">
            <div class="text">
              <div>
                Username: <strong>{{ instance.hdpUsername ?? "-" }}</strong>
              </div>
              <div>
                Password: <strong>{{ data.password }}</strong>
              </div>
            </div>
            <div class="icons">
              <mat-icon svgIcon="copy-16" (click)="copyTextToClipboard($event, instance.hdpUsername ?? '-')"></mat-icon>
              <mat-icon svgIcon="copy-16" (click)="copyTextToClipboard($event, data.password)"></mat-icon>
            </div>
          </div>
        </div>
        <!-- <div>
          You'll have view-only access to existing connectors in the Data Pipeline. To explore the list of available connectors and how to
          easily integrate different data sources, scroll to the 'Data Integrations' section on this
          <a href="https://help.board.com/docs/cloud-architecture" target="_blank">page</a>.
        </div> -->
        <!-- <h3>SLEEP MODE POLICY</h3>
        <div>
          If you don't access your environment for more than {{ sleepInterval }} hours, we will put it off-line - in sleep mode (for
          cost-saving purposes)<br />To put it back online, come back to the DEMO Portal and click the "Start" button: your environment will
          reactivate in a few minutes.
        </div>
        <h3>EXPIRY - CANCELLATION POLICY</h3>
        <div>
          After {{ deleteInterval }} hours of inactivity the environment is automatically deleted. <br />Next time you need to do another
          demo, simply create a new environment: it’ll take few minutes.
        </div> -->
      </div>
      <ng-template #noAccess>
        <div class="how-to-section">
          <h2 class="title">HOW TO ACCESS YOUR BOARD DEMO</h2>
          <div>
            To access your demo environment, click the “Open” button or go to the following
            <a [href]="instance.link" target="_blank">link</a>.
          </div>
          <div class="hdp-section">
            To access the Demo Data pipeline, you can use the following <a [href]="hdpAddress" target="_blank">link</a>.
          </div>
        </div>
      </ng-template>
    </div>
    <div class="info-button-container">
      <div class="action-board-version">
        <span>Board version</span>
        <strong>{{ instance.boardVersion }}</strong>
      </div>
      <div class="card-actions">
        <mat-icon matTooltip="Ask support" matTooltipPosition="below" svgIcon="label-16" (click)="askSupprt()"></mat-icon>
        <mat-icon
          *ngIf="!isLoading && instance.canDelete"
          matTooltip="Delete"
          matTooltipPosition="below"
          svgIcon="trash-16"
          (click)="deleteDemo($event, instance.title, instance.id, instance.owner)"
        ></mat-icon>
        <mat-icon
          *ngIf="instance.powerStateText === 'Online'"
          matTooltip="Put in Sleep Mode"
          matTooltipPosition="below"
          svgIcon="sleep-16"
          (click)="stopDemo($event, instance.title, instance.id)"
        ></mat-icon>
        <mat-icon
          matTooltip="Copy Demo URL"
          matTooltipPosition="below"
          svgIcon="copy-16"
          (click)="copyTextToClipboard($event, instance.link)"
        ></mat-icon>
        <mat-icon
          *ngIf="isActive$ | async"
          matTooltip="Go to Subscription Hub"
          matTooltipPosition="below"
          svgIcon="user-idp-16"
          (click)="openNewWindow($event, instance.linkSubHub)"
        ></mat-icon>
        <mat-icon
          *ngIf="isActive$ | async"
          matTooltip="Go to Admin Portal"
          matTooltipPosition="below"
          svgIcon="gear-16"
          (click)="openNewWindow($event, instance.linkAdminPortal)"
        ></mat-icon>
        <mat-icon
          *ngIf="instance.canDelete"
          matTooltip="Demo snapshot"
          matTooltipPosition="below"
          svgIcon="cloud-arrow-up-16"
          (click)="infoSnapshotClick($event)"
        ></mat-icon>
      </div>
      <brd-button
        *ngIf="!isLoading"
        [text]="(isActive$ | async) ? 'open' : 'restart'"
        [color]="(isActive$ | async) ? 'primary' : 'secondary'"
        [iconName]="(isActive$ | async) ? 'open-up-16' : 'reload-16'"
        [class]="{ 'restart-btn': (isActive$ | async) === false }"
        (click)="handleButtonClick($event)"
      ></brd-button>
    </div>
  </div>
</ng-template>

<ng-template #snapshotdialog let-data="data">
  <div class="info-container">
    <div class="snapshot-body-container">
      <span>
        From this section, you can create a snapshot of your demo instance or regenerate it if one already exists. A snapshot represents a
        complete copy of all Board data associated with your instance, including the database, capsule, and related components. Once the
        snapshot creation is complete, <strong>you may reference the label below during the standard POC request process</strong> to specify
        which snapshot the cloud operator should use when creating the POC environment.
      </span>
      <h2 class="title">Details</h2>
      @if (!demoSnapshot) {
        <div class="snapshot-missing">Demo snapshot has not been created yet.</div>
      } @else if (demoSnapshot.snapshotStatus === snapshotStatusEnum.creating) {
        <div class="snapshot-message">Snapshot creation is in progress. Please come back later.</div>
      } @else if (demoSnapshot.snapshotStatus === snapshotStatusEnum.error) {
        <div class="snapshot-message">
          An error occurred during snapshot creation. Please try again. If the issue persists, please contact us by completing the form
          available on <a routerLink="/support">the support page</a>.
        </div>
      } @else {
        <div class="snapshot-detail-container">
          <div class="snapshot-detail">
            <div class="snapshot-detail-label">Label</div>
            <div class="snapshot-detail-value">
              {{ demoSnapshot.snapshotLabel }}
              <mat-icon title="Copy label" svgIcon="copy-16" (click)="copyTextToClipboard($event, demoSnapshot.snapshotLabel)"></mat-icon>
            </div>
          </div>
          <div class="snapshot-detail">
            <div class="snapshot-detail-label">Last update</div>
            <div class="snapshot-detail-value">{{ snapshotDateFormatted }}</div>
          </div>
          <div class="snapshot-detail">
            <div class="snapshot-detail-label">Update by</div>
            <div class="snapshot-detail-value">{{ demoSnapshot.snapshotCreator }}</div>
          </div>
        </div>
      }
    </div>

    <div class="info-button-container snapshot-button-container">
      <brd-button
        *ngIf="enableSnaphotButton()"
        [text]="createSnapshotBtnText"
        color="primary"
        (clickEvent)="addOrUpdateSnapshot()"
      ></brd-button>
      <mat-progress-spinner diameter="30" mode="indeterminate" strokeWidth="4" *ngIf="submitting()"></mat-progress-spinner>
    </div>
  </div>
</ng-template>
